import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

interface ILetContext<T> {
  appLet: T;
}

/**
 * This directive is a Hack to be able to make single subscription in templates where no need to use
 * {@link @NgIf} angular directive.
 *
 * This is a known issue in Angular templates
 *
 * @see https://github.com/angular/angular/issues/15280 Angular Git Issue for the case
 * @todo remove this directive after the problem will be handled by pure angular templates
 *
 * @example Without additional tag
 *
 *     @Component({
 *       selector: '...',
 *       template: `
 *         <ng-container *appLet="data$ | async as data"> <!-- single subscription -->
 *           <div>
 *             Data: {{data}} <!-- false -->
 *           </div>
 *           <div>
 *             Data: {{data}} <!-- false -->
 *           </div>
 *         </ng-container>
 *       `,
 *     })
 *     export class App {
 *       data$: Observable<boolean> = of(false);
 *     }
 *
 * @example Using additional tag
 *
 *     <p *appLet="data$ | async as data"> <!-- single subscription -->
 *       <span>
 *         Data: {{data}} <!-- false -->
 *       </span>
 *       <span>
 *         Data: {{data}} <!-- false -->
 *       </span>
 *     </p>
 *
 */
@Directive({
  selector: '[appLet]',
})
export class LetDirective<T> implements OnInit {
  @Input()
  public set appLet(value: T) {
    this._context.appLet = value;
  }

  private _context: ILetContext<T> = { appLet: undefined };

  public constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly templateRef: TemplateRef<ILetContext<T>>,
  ) {}

  public ngOnInit(): void {
    this.viewContainer.createEmbeddedView(this.templateRef, this._context);
  }
}
